import type { PageContext } from "vike/types";
import type { Data } from "./+data";
import { staticMetaFor } from "./staticMeta";

// tab title priority: bio page title, profile handle, static route title,
// site default
export default function title(pageContext: PageContext<Data>): string {
  const { bio, profile } = pageContext.data ?? { bio: null, profile: null };
  return (
    bio?.title ??
    (profile ? `@${profile.username}` : null) ??
    staticMetaFor(pageContext.urlPathname)?.title ??
    "clove.moe - free bio link page builder | better than linktree"
  );
}
